import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M35.867 32.178 23.689 20 35.867 7.822a20.206 20.206 0 0 0-3.69-3.689L20 16.311 7.822 4.133a20.19 20.19 0 0 0-3.689 3.69L16.311 20 4.133 32.178a20.208 20.208 0 0 0 3.69 3.689L20 23.689l12.178 12.178a20.2 20.2 0 0 0 3.689-3.69Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m16.522 6.087 3.478.87 3.478-.87V3.13l-1.391.696L20 1.74l-2.087 2.087-1.391-.696v2.957Z"
}, null, -1), d = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M16.522 6.087V8.26c0 2.663 3.478 3.478 3.478 3.478s3.478-.816 3.478-3.478V6.087h-6.956Z"
}, null, -1), i = [
  n,
  s,
  c,
  d
];
function _(a, h) {
  return e(), l("svg", o, [...i]);
}
const f = { render: _ };
export {
  f as default,
  _ as render
};
